// Restrições alimentares. Chips com "Como de tudo" exclusivo (§ 3 e a lista
// do Objetivo.dc.html). O payload é o de sempre:
// RESTRICAO_ALIMENTAR (boolean) + RESTRICAO_ALIMENTAR_DETAILS (texto).

import React from "react";

import ChipsComOutro from "./ChipsComOutro.jsx";

const OPCOES = [
  { value: "tudo", label: "Como de tudo" },
  { value: "lactose", label: "Lactose" },
  { value: "gluten", label: "Glúten" },
  { value: "carne_vermelha", label: "Carne vermelha" },
  { value: "porco", label: "Porco" },
  { value: "frutos_do_mar", label: "Frutos do mar" },
  { value: "ovos", label: "Ovos" },
  { value: "soja", label: "Soja" },
  { value: "amendoim", label: "Amendoim" },
];

const StepResAlimentares = (props) => (
  <ChipsComOutro
    {...props}
    opcoes={OPCOES}
    exclusivo="tudo"
    placeholder="Ex.: alergia a frutos do mar, intolerância a frutose…"
    chaveBool="RESTRICAO_ALIMENTAR"
    chaveTexto="RESTRICAO_ALIMENTAR_DETAILS"
  />
);

export default StepResAlimentares;
